import { configureStore } from "@reduxjs/toolkit";
import GlobalVar from "./Reducers/GlobalVar";

import { persistReducer, persistStore } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session"; 

const persistConfig = {
  key: "root",
  storage: storageSession,
};
const persistedReducer = persistReducer(persistConfig, GlobalVar);

export const store = configureStore({
  reducer: {
    global: persistedReducer,
  },
 middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/FLUSH",
          "persist/PAUSE",
          "persist/PURGE",
          "persist/REGISTER",
        ],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;